window.accordionItemToggle = function(id) {
    $("#"+id).slideToggle(200);
    if ($("#"+id).closest(".bk-accordion__item").hasClass("bk-accordion__item--open")) {
        $("#"+id).closest(".bk-accordion__item").removeClass("bk-accordion__item--open");
    } else {
        $("#"+id).closest(".bk-accordion__item").addClass("bk-accordion__item--open");
    }
}
